// Date utilities — all return values are based on the user's LOCAL wall clock.
// Using `toISOString().slice(0, 10)` for "today" breaks in non-UTC timezones
// (notably NZ at UTC+12/13) because local midnight is the previous day in UTC.
// Always import from this module instead of constructing date strings inline.

/** Return YYYY-MM-DD for the given Date (or `new Date()` if omitted) in LOCAL time. */
export function localIsoDay(d = new Date()) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

/** Today (YYYY-MM-DD) in the user's local timezone. */
export function todayIso() {
  return localIsoDay(new Date());
}

/** Shift a YYYY-MM-DD string by N whole days (positive or negative). */
export function shiftIsoDay(iso, deltaDays) {
  const d = new Date(iso + "T00:00:00");
  d.setDate(d.getDate() + deltaDays);
  return localIsoDay(d);
}

/** Operational "today" in New Zealand, independent of device timezone. */
export function nzTodayIso(d = new Date()) {
  const parts = new Intl.DateTimeFormat('en-NZ', {timeZone:'Pacific/Auckland', year:'numeric', month:'2-digit', day:'2-digit'}).formatToParts(d);
  const get = type => parts.find(p => p.type === type).value;
  return `${get('year')}-${get('month')}-${get('day')}`;
}

/** Human-readable date-only values without UTC shifting the calendar day. */
export function displayDate(value) {
  if (!value) return '—';
  const date = new Date(String(value).slice(0, 10) + 'T12:00:00');
  return Number.isNaN(date.getTime()) ? '—' : date.toLocaleDateString('en-NZ', {day: 'numeric', month: 'short', year: 'numeric'});
}

/** Display an audit timestamp in NZ time, independently of the device timezone. */
export function displayNzTimestamp(value) {
  if (!value || !/T\d{2}:\d{2}.*(?:Z|[+-]\d{2}:\d{2})$/i.test(String(value))) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '—';
  return new Intl.DateTimeFormat('en-NZ', {
    timeZone: 'Pacific/Auckland', day: 'numeric', month: 'short', year: 'numeric',
    hour: 'numeric', minute: '2-digit', hour12: true,
  }).format(date) + ' (NZ)';
}
